import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AddEditCliententityAPIRequestInterface, PostClientsFromXeroAPIRequestInterface } from './xero.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class XeroService {

    private headers: HttpHeaders;

    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders();
        this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    GetCallBack(code, state) {
        return this.http.get<any>('Integration/CallbackMain?Code=' + code + '&State=' + state);
    }

    GetMappingsByConnectionId(connectionId) {
        return this.http.get<any>('Settings/Connection/Mappings/' + connectionId);
    }

    postClientsFromXero(requestBody: PostClientsFromXeroAPIRequestInterface): Observable<any> {
        return this.http.post<any>('Integration/PostClientsFromXero', requestBody, { headers: this.headers });
    }

    PostClientsFromXero(XeroData) {
        return this.http.post<any>('Integration/PostClientsFromXero', XeroData, { headers: this.headers });
    }

    manualSynchronization(connectionId): Observable<any> {
        return this.http.get<any>('Integration/Manualsynchronization?connectionId=' + connectionId + '&isManualSync=true');
    }

    AddEditBusinessStructure(businessStructure) {
        return this.http.post<any>('Integration/AddEditBusinessStructure', businessStructure, { headers: this.headers });
    }

    GetBusinessStructureDetailsByConnectionID(connectionId) {
        return this.http.get<any>('Integration/GetBusinessStructureDetailsByConnectionID?connectionId=' + connectionId);
    }

    GetAllBusinessStructure() {
        return this.http.get<any>('Integration/GeAllBusinessStructure', { headers: this.headers });
    }

   getAllBillingEntities(){
    return this.http.get<any>('BillingEntity/GetAllBillingEntitiesforselect?IsArchived=false', { headers: this.headers });
   }
    
    searchConnection(connectionType: string, query: string = '', fetchType: number = 0): Observable<any> {
        const url = `Settings/Connection/Search`;
        const requestBody = {
            connectionType: connectionType,
            query: query,
            fetchType: fetchType
        };
        return this.http.post<any>(url, requestBody, { headers: this.headers });
    }

    getConnectionAutenticationhUrl(id: string): Observable<any> {
        const url = `Settings/Connection/AuthenticationUrl/${id}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addConnection(requestBody: any): Observable<any> {
        return this.http.post('Settings/Connection/Add', requestBody)
    }

    updateConnection(requestBody: any): Observable<any> {
        return this.http.post('Settings/Connection/Update', requestBody)
    }

    disconnectConnection(connectionId: any): Observable<any> {
        const url = `Settings/Connection/Disconnect/${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });        
    }
    
    deleteConnection(connectionId: any): Observable<any> {
        const url = `Settings/Connection/Delete/${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });        
    }

    synchronizeConnectionData(connectionId: any): Observable<any> {
        const url = `Integration/SynchronizeConnectionData?connectionIds=` + connectionId + `&manualSynchronization=true&lastSynchronized=''`;
        return this.http.get<any>(url, { headers: this.headers });          
    }

    getClientDetailsPaging(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/SearchIntegrationDataPaging', requestBody, { headers: this.headers })
    }

    GetClientDetailsById(connectionId: string, clientId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetClientDetailsById?connectionId=${connectionId}&clientId=${clientId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetClientAddressDetailsById(connectionId: string, clientId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetClientAddressDetailsById?connectionId=${connectionId}&clientId=${clientId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    AddEditClientFromConnection(requestBody: any):Observable<any> {
        return this.http.post<any>('Integration/AddEditClientFromConnection', requestBody, { headers: this.headers })
    }

    GetClientConnectionRelationShipsById(connectionId: string, clientId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetClientRelationShipsById?connectionId=${connectionId}&clientId=${clientId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetClientConnectionDetailsById(connectionId: string, kcClientId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetClientConnectionDetailsById?connectionId=${connectionId}&clientId=${kcClientId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetClientRedirectUrl(connectionId: string, clientId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetClientRedirectUrl?connectionId=${connectionId}&clientId=${clientId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetXeroBlueOrganizations(connectionId: string, organizationId: string): Observable<any> {
        const url = `Integration/GetXeroBlueOrganizations?connectionId=${connectionId}&xeroOrganizationId=${organizationId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
 
    GetXeroBlueTenants(connectionId: string): Observable<any> {
        const url = `Integration/GetXeroBlueTenants/${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
 
    GetXeroBlueOrganizationTrackingCategories(connectionId: string, organizationId: string): Observable<any> {
        const url = `Integration/GetOrganizationTrackingCategories?connectionId=${connectionId}&xeroOrganizationId=${organizationId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
 
    GetDivisionsByBillingEntityId(billingEntityId: string): Observable<any> {
        const url = `BillingEntity/GetDivisionsByBillingEntityId?billingEntityId=${billingEntityId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
 
    GetConnectionConfiguration(connectionId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetConnectionConfiguration?connectionId=${connectionId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
 
    AddEditConnectionConfiguration(request: any): Observable<any> {        
        return this.http.post<any>('Settings/Connection/Configure', request, { headers: this.headers });
    }
 
    GetXeroBlueOrganizationAccounts(connectionId: string, organizationId: string): Observable<any> {
        const url = `Integration/GetXeroBlueAccounts?connectionId=${connectionId}&xeroOrganizationId=${organizationId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetAvailableMappingsByConnectionType(connectionType: string, mappingType: number): Observable<any> {
        const url = `Settings/Connection/AvailableMappings/${connectionType}/${mappingType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getOfficesByConnectionId(connectionId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetOfficesByConnection?connectionId=${connectionId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getOfficesByClientId(clientId: string, connectionType: string, connectionId: string): Observable<any> {
        const url = `Integration/GetOfficesByClient?clientId=${clientId}&connectionType=${connectionType}&connectionId=${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getPartners(clientId: string, officeId: string, connectionType: string, connectionId: string): Observable<any> {
        const url = `Integration/GetPartnersByClientId?clientId=${clientId}&connectionType=${connectionType}&officeId=${officeId}&connectionId=${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getPartnersByConnection(connectionId: string, officeId: string, connectionType: string): Observable<any> {
        const url = `Integration/GetPartnersByConnection?connectionId=${connectionId}&connectionType=${connectionType}&officeId=${officeId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    unMatchClientsFromConnection(requestBody) {
        return this.http.post<any>('Integration/UnMatchClients', requestBody, { headers: this.headers });
    }

    matchClients(requestBody) {
        return this.http.post<any>('Integration/MatchClients', requestBody, { headers: this.headers });
    }

    getConnectionEntityRelationshipDetails(request: any){
        return this.http.post<any>('Integration/GetConnectionEntityRelationshipDetails', request, { headers: this.headers });
    }

    bulkSubmitNIAddressChangeForm(request: any[]){
        return this.http.post<any>('Integration/BulkSubmitNIAddressChangeForm', request, { headers: this.headers });
    }

    GetDivisionsByMultipleBillingEntityIds(billingEntityId: string): Observable<any> {
        const url = `BillingEntity/GetDivisionsByMultipleBillingEntityIds?billingEntityId=${billingEntityId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }  
        

    getClientRelationshipByClientId(clientId: number): Observable<any> {
        const url = `Client/GetClientRelationship?ClientId=${clientId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getLinkedSoftwaresByClientIds(clientIds: string): Observable<any> {
        const url = `Integration/GetLinkedSoftwaresByIds/${clientIds}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

   getLodgements(uuid: string, connectionId: string, connectionType): Observable<any> {
        const url = `Integration/GetLodgementsById?id=${uuid}&connectionId=${connectionId}&connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    
    downloadNowInfinityDocument(payload: {documentId: string, fileName: string, connectionId: string, connectionType: string | null, fileUrl: string | null} ): Observable<HttpResponse<Blob>>  {
        return this.http.get(`Integration/DownloadDocument?documentID=${payload?.documentId}&filename=${payload?.fileName}&connectionId=${payload?.connectionId}&connectionType=${payload?.connectionType}&fileUrl=${payload?.fileUrl}`, { responseType: 'blob', observe: 'response' });
    }

    suggestClientOrContact(requestBody) {
        return this.http.post<any>('Integration/SuggestClientOrContact', requestBody, { headers: this.headers });
    }

    getSupportWidgetKey(): Observable<string> {
        const url = `Integration/GetSupportWidgetKey`;
        return this.http.get(url, { headers: this.headers, responseType: 'text' });
    }

    getFromEmailList(mappingId: string, connectionType: string): Observable<any> {
        const params = new HttpParams()
            .set('mappingId', mappingId || '')
            .set('connectionType', connectionType || '');
        return this.http.get<any>('Integration/GetConnectionsByMappingId', { headers: this.headers, params });
    }

      getFuseSignDocList() {
      return this.http.get<any>('Integration/GetFuseSignDocumentDetails');
  }
  
  downloadFileFromFuseSign(connectionId, tenantId, fuseSignDocumentId,bundledId,fileName) {
    const url ='Integration/DownloadFileFromFuseSign?connectionId=' + connectionId + '&tenantId=' + tenantId + '&fuseSignDocumentId=' + fuseSignDocumentId + '&bundledId=' + bundledId + '&fileName=' + fileName;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/octet-stream'
    });
  
    // Make a GET request to fetch the blob
    return this.http.get(url, {
      headers: headers,
      responseType: 'blob',
      observe: 'response'
    });
  }
  
  uploadFileFromFuseSign(data) {
    return this.http.post<any>('Integration/BundleStatusChanged',data);
  }

  getClientLinkedSoftware(id: number): Observable<any> {
    const url = `Integration/GetClientLinkedSoftwares/${id}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  getClientVerifiedRelationships(connectionId: string, clientId: number, connectionType: string): Observable<any> {
    const url = `Integration/GetClientsVerifiedRelationships?connectionId=${connectionId}&clientId=${clientId}&connectionType=${connectionType}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  addSubmitAddressChangeForm(requestBody: any): Observable<any> {
    return this.http.post<any>('Integration/SubmitAddressChangeForm', requestBody, { headers: this.headers })
  }

  GetContactDetailById(id) {
    return this.http.get<any>('Integration/GetContactDetailsById?ContactId=' + id);
  }

    getIManageLibraries(connectionId: string): Observable<any> {
        const url = `Integration/DMS/IManage/GetIManageLibraries/${connectionId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addLibraryLink(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/AddLibrary', requestBody, { headers: this.headers })
    }

    searchLibrary(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/SearchLibraries', requestBody, { headers: this.headers })
    }

    UpdateLibrary(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateLibrary', requestBody, { headers: this.headers })
    }

    deleteLibrary(linkId: string): Observable<any> {
        const url = `Integration/DMS/IManage/DeleteLibrary/${linkId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addTemplate(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/addTemplate', requestBody, { headers: this.headers })
    }

    updateTemplate(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateTemplate', requestBody, { headers: this.headers })
    }

    searchTemplate(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/SearchTemplates', requestBody, { headers: this.headers })
    }

    deleteTemplate(templateId: string): Observable<any> {
        const url = `Integration/DMS/IManage/DeleteTemplate/${templateId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addWorkspace(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/AddWorkspace', requestBody, { headers: this.headers })
    }

    updateWorkspace(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateWorkspace', requestBody, { headers: this.headers })
    }

    searchWorkspaces(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/SearchWorkspaces', requestBody, { headers: this.headers })
    }

    deleteWorkspace(workspaceId: string): Observable<any> {
        const url = `Integration/DMS/IManage/DeleteWorkspace/${workspaceId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getKloudMappingFields(): Observable<any> {
        return this.http.get<any>('Integration/DMS/IManage/GetKloudMappingFields', { headers: this.headers })
    }

    getIManageCustomFields(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/GetIManageCustomFields', requestBody, { headers: this.headers })
    }

    searchFieldmappings(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/SearchFieldMappings', requestBody, { headers: this.headers })
    }

    addFieldMapping(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/AddFieldMapping', requestBody, { headers: this.headers })
    }

    updateFieldMapping(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateFieldMapping', requestBody, { headers: this.headers })
    }

    deleteFieldMapping(fieldMappingId: string): Observable<any> {
        const url = `Integration/DMS/IManage/DeleteFieldMapping/${fieldMappingId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getTemplateSchema(templateId: string): Observable<any> {
        const url = `Integration/DMS/IManage/GetTemplateDefinition/${templateId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addTemplateSchema(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/AddTemplateDefinition', requestBody, { headers: this.headers })
    }

    updateTemplateSchema(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateTemplateDefinition', requestBody, { headers: this.headers })
    }

    getIManageDocumentsRedirectUrl(entityType: string, entityCode: string) {
        const url = `Integration/DMS/IManage/GetIManageDocumentsRedirectUrl/${entityType}/${entityCode}`;
        return this.http.get(url, {
            headers: this.headers,
            responseType: 'text' as 'json'
        });
    }

    getIManageWorkspaceNameFormats(formatFetchType: number): Observable<any> {
        const url = `Integration/DMS/IManage/GetIManageWorkspaceNameFormats/${formatFetchType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getFirmsIManageWorkspaceNameFormatMapping(nameFormatType: number): Observable<any> {
        const url = `Integration/DMS/IManage/GetFirmsIManageWorkspaceNameFormatMapping/${nameFormatType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    addFirmsIManageWorkspaceNameFormatMapping(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/AddFirmsIManageWorkspaceNameFormatMapping', requestBody, { headers: this.headers })
    }

    updateFirmsIManageWorkspaceNameFormatMapping(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/DMS/IManage/UpdateFirmsIManageWorkspaceNameFormatMapping', requestBody, { headers: this.headers })
    }

    bulkEditClientFromConnection(requestBody: any): Observable<any> {
        return this.http.post<any>('Integration/BulkEditClientFromConnection', requestBody, { headers: this.headers })
    }
    synchronizeConnectionClientGroupsAsync(connectionId: any): Observable<any> {
            const url = `Integration/SynchronizeConnectionClientGroupsAsync?connectionId=` + connectionId;
            return this.http.get<any>(url, { headers: this.headers });          
    }

    getClientSyncLinkFields(connectionTypes: string) {
        return this.http.post(`Integration/GetClientSyncFields`, null,
            {
                params: { connectionTypes: connectionTypes }
            }
        );
    }

    getConnectionEntityFields(connectionType: string): Observable<any> {
        const url = `Integration/GetConnectionEntityFields?connectionType=${connectionType}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getDocumentsRedirectUrl(entityType: string, entityCode: string, connectionType: string, connectionId: string, clientId: string, moduleName?: string) {
        const url = `Integration/DMS/GetDocumentsRedirectUrl`;
        
        let params = new HttpParams();
        params = params.set('entityType', entityType);
        params = params.set('entityCode', entityCode);
        params = params.set('connectionType', connectionType);
        params = params.set('connectionId', connectionId);
        params = params.set('clientId', clientId);
        if (moduleName) params = params.set('moduleName', moduleName);

        return this.http.get(url, { headers: this.headers, params: params, responseType: 'text' as 'json' });
    }

    getClientFieldsByConnection(clientEntityType: string, connectionId: string): Observable<any> {
        return this.http.post<any>(`Integration/GetClientExceptionFieldsByConnection`, null,
            {
                params: { clientEntityType: clientEntityType, connectionId: connectionId }
            }
        );
    }

    getAllTagList(): Observable<any> {
        return this.http.get<any>('Settings/GetTagdetailssettings');
    }

    getAllOffices(): Observable<any> {
        return this.http.get<any>('Office/GetOffices');
    }

    
}